// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"911":"css/app.7016","6950":"css/admin-app.7016"}[chunkId] + ".css";
};